import { render, staticRenderFns } from "./insuranceCompanyInfoCollect.vue?vue&type=template&id=5c4e8c66&scoped=true&"
import script from "./insuranceCompanyInfoCollect.vue?vue&type=script&lang=js&"
export * from "./insuranceCompanyInfoCollect.vue?vue&type=script&lang=js&"
import style0 from "./insuranceCompanyInfoCollect.vue?vue&type=style&index=0&id=5c4e8c66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4e8c66",
  null
  
)

export default component.exports